import axios from './axios'
import appInfo from '@/assets/js/appInfo'
let activityId = appInfo.getParam('activityId') || '1004'
/***
 * 提交预定人信息
 */

class Activity {
  submitApi(params) {
    return axios({
      url: '/Order/Extend/Submit',
      method: 'post',
      data: params
    })
  }
  // 获取模版
  getPicTemplate() {
    return axios.get(
      `/Activity/Ticket/GetActivityInfo?activityId=${activityId}`
    )
  }
}

export default new Activity()
